export const Currencies = {
    0: {
        code: "",
        symbol: "",
        name: ""
    },
    1: {
        code: "USD",
        symbol: "$",
        name: "US Dollar"
    },
    2: {
        code: "NIS",
        symbol: "₪",
        name: "New Israeli Shekel"
    },
    3: {
        code: "EUR",
        symbol: "€",
        name: "Euro"
    },
    4: {
        code: "GBP",
        symbol: "£",
        name: "United Kingdom Pound"
    },
    5: {
        code: "HUF",
        symbol: "Ft",
        name: "Hungarian Forint"
    },
    6: {
        code: "PLN",
        symbol: "Zl",
        name: "Polish Zloty"
    },
    7: {
        code: "BGN",
        symbol: "BG",
        name: "Bulgarian Lev"
    },
    8: {
        code: "PHP",
        symbol: "₱",
        name: "Philippine Peso"
    },
    9: {
        code: "CAD",
        symbol: "C$",
        name: "Canadian Dollar"
    },
    10: {
        code: "RON",
        symbol: "lei",
        name: "Romanian Leu"
    },
    11: {
        code: "CHF",
        symbol: "CHF",
        name: "Swiss Franc"
    },
    12: {
        code: "CZK",
        symbol: "CZK",
        name: "Czech Koruna"
    },
    13: {
        code: "ZAR",
        symbol: "R",
        name: "South African Rand"
    },
    14: {
        code: "NAD",
        symbol: "$",
        name: "Namibian Dollar"
    },
    15: {
        code: "BWP",
        symbol: "P",
        name: "Botswana Pula"
    },
    16: {
        code: "TZS",
        symbol: "TSh",
        name: "Tanzanian Shilling"
    },
    17: {
        code: "KES",
        symbol: "KSh",
        name: "Kenyan Shilling"
    }
}

export const CurrencyIds = {
    USD: 1,
    NIS: 2,
    EUR: 3,
    GBP: 4,
    HUF: 5,
    PLN: 6,
    BGN: 7,
    PHP: 8,
    CAD: 9,
    RON: 10,
    CHF: 11,
    CZK: 12,
    ZAR: 13,
    NAD: 14,
    BWP: 15,
    TZS: 16,
    KES: 17
}